import { Navigate } from 'react-router-dom';

import { ROUTES } from '@/lib/constants/routes';

import { LoginForm } from '../components';
import { useAuth } from '../hooks';

const DASHBOARD_PERMISSIONS = [
  { resource: 'md-statistic', action: 'get' },
  { resource: 'partner-statistic', action: 'get' },
  { resource: 'accountant-statistic', action: 'get' },
  { resource: 'lawyer-statistic', action: 'get' },
];

export function LoginPage() {
  const { isAuthenticated, isLoading, hasAccess } = useAuth();

  if (isLoading) {
    return (
      <div className="flex h-screen items-center justify-center">
        <div className="text-muted-foreground">Loading...</div>
      </div>
    );
  }

  if (isAuthenticated) {
    const hasDashboardAccess = DASHBOARD_PERMISSIONS.some(({ resource, action }) =>
      hasAccess(resource, action)
    );
    return <Navigate to={hasDashboardAccess ? ROUTES.DASHBOARD : ROUTES.CLIENTS} replace />;
  }

  return (
    <div className="flex h-screen w-full items-center justify-center">
      <LoginForm />
    </div>
  );
}
